import { Link, useLocation } from "react-router-dom";
import mainLogo from "../../assets/images/whitebull.png";
import { useState } from "react";

export default function FloatingLogoAndButton({ resMenuOpener }) {
  const [hidden, setHidden] = useState(true);
  const location = useLocation();
  const isReservationPage = location.pathname === "/rezerwacje";

  return (
    <>
      <div className="fixed top-0 left-0 z-30 w-screen md:w-full flex justify-between items-center px-2 md:px-4">
        <div className="flex items-center justify-center gap-4">
          <Link to="/">
            <img
              src={mainLogo}
              className="max-w-28 md:max-w-40"
              alt="WhiteBull Logo"
            />
          </Link>
          {!isReservationPage && (
            <Link
              to="https://praca.whitebull.com.pl"
              target="_blank"
              className="w-32 h-[76px] border-[1px] text-white bg-red-700 border-red-700 uppercase font-bold mt-3 flex items-center justify-center rounded-sm"
            >
              Kariera
            </Link>
          )}
        </div>

        {!isReservationPage && (
          <div className="flex items-center justify-center gap-6">
            <button
              onClick={() => {
                setHidden(!hidden);
              }}
              className="w-32 h-[76px] border-[1px] text-white bg-red-700 border-red-700 uppercase font-bold mt-3 flex items-center justify-center rounded-sm"
            >
              Rezerwuj
            </button>
          </div>
        )}
      </div>
      {!hidden && (
        <div
          className={`z-40 h-screen w-full bg-black text-white flex items-center justify-center absolute`}
        >
          <button
            className="fixed top-8 right-8"
            onClick={() => {
              setHidden(!hidden);
            }}
          >
            [ <span className="font-bold text-red-500 hover:text-white">X</span>{" "}
            ]
          </button>
          <ul className="flex flex-col gap-4">
            <li className="hover:text-red-500">
              {" "}
              <Link to="https://zjedz.my/whitebull-steakhouse" target="_blank">
                Toruń
              </Link>
            </li>
            <li className="hover:text-red-500">
              <Link to="https://zjedz.my/whitebull-bydgoszcz" target="_blank">
                Bydgoszcz
              </Link>
            </li>
            <li className="hover:text-red-500">
              <Link
                to="https://zjedz.my/whitebull-steakhouse-7"
                target="_blank"
              >
                Gdańsk
              </Link>
            </li>
          </ul>
        </div>
      )}
    </>
  );
}
